export const environment = {
  production: true,
  buildId: '3520240673122431',
  configFile: 'config.json',
};
